import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import { fmtDate } from '../../../../utils/fmt';

const OpportunityCallListDetails = () => {
  const columns = [
    { label: 'Call Date', value: (item) => fmtDate(item.call_date) },
    { label: 'Description', value: 'description' },
    { label: 'Access Details', value: (id) => <button onClick={() => handleAccessDetails(id)}>Access Details</button> },
  ];
  const handleAccessDetails = (id) => {
    const encodedId = btoa(id);
    window.location.href = '/opportunity/call/details/' + encodedId;
  };
  return <ListTemplate fetchUrl={API_DOMAIN + API_ROUTES['opportunityCall']} columns={columns} onAccessDetails={handleAccessDetails} />;
};

export default OpportunityCallListDetails;